import { useMatches } from 'react-router-dom';

/**
 * How wide a page in the Forge, Eval, Archon and Lurker shells may grow. Every page route declares
 * one in its `handle`, and `src/navigation/pageWidth.test.tsx` fails for a page that does not.
 *
 * - `full`: a tool people work in (labeling, review, a crop grid, an image viewer), or a page built
 *   around a table with many columns (Designs, Cleaning tasks). It uses the whole screen, because a
 *   wider screen shows more of the work or more of each row.
 * - `capped`: a chart dashboard, a short list or a form. It stays as wide as on a 1920px monitor
 *   (`--forge-page-max-width`), so its charts and text do not stretch across an ultrawide.
 */
export type PageWidth = 'capped' | 'full';

export const PAGE_WIDTHS: readonly PageWidth[] = ['capped', 'full'];

export interface PageWidthHandle {
  pageWidth: PageWidth;
}

/** The matched page's width, for the shell's `<main data-page-width>`. Redirects read as capped. */
export function usePageWidth(): PageWidth {
  const matches = useMatches();
  const handle = matches[matches.length - 1]?.handle as Partial<PageWidthHandle> | undefined;
  return handle?.pageWidth ?? 'capped';
}
